import get from "lodash/get";
import find from "lodash/find";
import {setLastSentMessage} from "../../Shared/actions/chatActions";

const writeOptimisticMessageToApolloCache = (
    {messagesQuery, store, variables, sendMessageResponse},
    dispatchFn,
) => {
    // Read the data from our cache for this query.
    const data = store.readQuery({
        query: messagesQuery,
        variables,
    });

    // ignore message which are already in the store.
    // i.e message which I have sent.
    if (get(sendMessageResponse, "message")) {
        if (
            !find(data.messages.messages, {
                id: sendMessageResponse.message.id,
            })
        ) {
            // Add our message from the mutation to the end.
            data.messages.messages.push(sendMessageResponse.message);

            // Write lastSentMessage to redux store
            if (dispatchFn) {
                dispatchFn(setLastSentMessage(sendMessageResponse.message));
            }
        }
    }
    if (Array.isArray(sendMessageResponse.botMessages)) {
        sendMessageResponse.botMessages.forEach((message) => {
            if (
                !find(data.messages.messages, {
                    id: message.id,
                })
            ) {
                // Add our message from the mutation to the end.
                data.messages.messages.push(message);
            }
        });
    }

    // Write our data back to the cache.
    store.writeQuery({
        query: messagesQuery,
        variables,
        data,
    });
};

export default writeOptimisticMessageToApolloCache;
